import Map from 'eemovel-map-library/src/data/google-maps/map';
import {
  addPolygon,
  removePolygons,
  updateDataLayers,
  updateOptionMarkers,
} from './dataLayers.actions';
// import { bankMarker } from '../../../../assets/markers/flowPoints';
import {
  clearDataLayers,
  shouldAddPoligon,
} from '../controllers/dataLayers.controller';
import {
  clearMap,
  closeAllCharts,
  setDisplayCharts,
} from '../../redux/dashboardActions';
import { updateDrawState } from '../../polygons/redux/polygonsActions';
import { FlowPoint } from '../components/flowPoints/flowPointsOptions';
import { Store } from '../../../../helpers';
import { AppDispatch } from '../../../../reducer';

export type generatePolygonsParams = {
  coordinates: google.maps.LatLng[];
  color: string;
  borderColor: string;
  polygonType: 'neighborhood' | 'valueZoning' | 'zoning' | 'averageIncome';
  infowindow?: google.maps.InfoWindowOptions;
  poligonStyles?: google.maps.PolygonOptions;
  clickedPoligonStyles?: google.maps.PolygonOptions;
};

export const generatePolygons = ({
  coordinates,
  color,
  borderColor,
  polygonType,
  infowindow,
  poligonStyles,
  clickedPoligonStyles,
}: generatePolygonsParams) => {
  const google = window.google;
  return (dispatch: AppDispatch) => {
    const newPolygon = new google.maps.Polygon({
      paths: coordinates,
      strokeColor: borderColor,
      strokeOpacity: 0.4,
      strokeWeight: 1,
      fillColor: color,
      ...poligonStyles,
    });
    if (infowindow) {
      generateInfoWindow(infowindow, newPolygon);
    }
    google.maps.event.addListener(newPolygon, 'click', () => {
      dispatch(
        updateDataLayers({
          name: polygonType,
          value: false,
        })
      );
      dispatch([
        removePolygons('neighborhood'),
        clearMap(),
        clearDataLayers(),
        closeAllCharts(),
        setDisplayCharts(null),
      ]);
      const newPolygon = new google.maps.Polygon({
        paths: coordinates,
        strokeColor: borderColor,
        strokeOpacity: 0.4,
        strokeWeight: 1,
        fillColor: color,
        ...clickedPoligonStyles,
      });
      if (infowindow) {
        generateInfoWindow(infowindow, newPolygon);
      }
      newPolygon.setMap(Map.map);
      Map.PoligonOnMap = newPolygon;

      dispatch(
        updateDrawState({
          type: 'polygon',
          radius: null,
          coords: newPolygon.getPath().getArray(),
          center: null,
          isActive: true,
        })
      );
    });
    if (shouldAddPoligon(polygonType, newPolygon)) {
      dispatch(
        addPolygon({
          name: polygonType,
          value: newPolygon,
        })
      );
      newPolygon.setMap(Map.map);
    }
  };
};

const generateInfoWindow = (
  iwData: google.maps.InfoWindowOptions,
  polygon: google.maps.Polygon
) => {
  const google = window.google;

  const iw = new google.maps.InfoWindow(iwData);
  const bounds = new google.maps.LatLngBounds();
  polygon.getPath().forEach(function (element, index) {
    bounds.extend(element);
  });
  const polyCenter = bounds.getCenter();
  polygon.addListener('mouseover', () => {
    iw.setPosition(polyCenter);
    iw.open(Map.map);
  });
  polygon.addListener('mouseout', () => {
    iw.close();
  });
};

interface GetFlowPoint {
  request: google.maps.places.PlaceSearchRequest;
  type: string;
  color: string;
}

function capitalizeTextInUppercase(upperCaseString: string | undefined) {
  if (!upperCaseString) return;
  return String(upperCaseString)
    .toLowerCase()
    .replace(/(?:^|\s|[-"'([{])+\S/g, (c) => c.toUpperCase());
}

const getIcon = (color = '#1DA9F7') => {
  const icon = window.btoa(`<svg
  width=".8em"
  height=".8em"
  viewBox="0 0 12 12"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <circle cx="6" cy="6" r="6" fill="${color}" />
</svg>`);

  return icon;
};

export const createInfoWindowFlowPoint = (
  address: any,
  name: any,
  location?: google.maps.LatLngLiteral
) => {
  /* eslint-disable no-param-reassign */
  /* eslint-disable no-nested-ternary */

  return `
      <div style="padding: 8px;max-height: 200px;max-width: 250px;">
        <div 
          style="font-size: 14px; width: 154px; font-weight: bold">${name}</div>
        <div style="margin-top: 8px;font-size: 12px;width: 150px;">${address}</div>
      
        <a target="_blank" href="https://www.google.com/maps/search/?api=1&query=${
          location?.lat
        },${
    location?.lng
  }" style="margin-top: 20px;font-size: 12px;width: 150px; display: ${
    !!location?.lat ? 'visible' : 'hidden'
  }">Visualize no Google Maps</a>
      </div>
    `;
};

const getGoogleFlowPoints = ({ request, type, color }: GetFlowPoint) => {
  return (dispatch: AppDispatch) => {
    const google = window.google;
    const service = new google.maps.places.PlacesService(Map.map);
    let result: google.maps.places.PlaceResult[] = [];
    service.nearbySearch(
      { ...request, type },
      (results, status, pagination) => {
        const isCircle = !!request.radius;

        if (results?.length) {
          result = [...result, ...results];
        }

        if (pagination?.hasNextPage) {
          pagination.nextPage();
        } else {
          const points = result
            ?.map((result) => {
              const coord = result.geometry?.location?.toJSON();
              const address = capitalizeTextInUppercase(result.vicinity);
              const name = capitalizeTextInUppercase(result.name);
              const infowindow = createInfoWindowFlowPoint(
                address,
                name,
                coord
              );
              const isInsidePolygon =
                isCircle ||
                (request.bounds &&
                  coord &&
                  google.maps.geometry.poly.containsLocation(
                    coord,
                    Map.PoligonOnMap
                  ));

              return {
                position: coord,
                isInsidePolygon,
                infowindow,
              };
            })
            .filter((point) => point.position && point.isInsidePolygon);

          const icon = getIcon(color);

          const markers = points.map((point) => {
            const infowindow = new google.maps.InfoWindow({
              content: point.infowindow,
            });
            allFlowPointsInfowindow.push(infowindow);

            const marker = new google.maps.Marker({
              position: point.position,
              icon: {
                url: `data:image/svg+xml;base64,${icon}`,
                scaledSize: new google.maps.Size(14, 14),
              },
              map: Map.map,
            });
            marker.addListener('click', () => {
              allFlowPointsInfowindow.forEach((infowindow) =>
                infowindow.close()
              );
              infowindow.open({
                anchor: marker,
                map: Map.map,
              });
            });
            return marker;
          });
          dispatch(updateOptionMarkers({ name: type, markers }));
        }
      }
    );
  };
};

interface ShowFlowPoint {
  radius?: number;
  center?: google.maps.LatLng | google.maps.LatLngLiteral;
  bounds?: google.maps.LatLngBounds;
  type: string;
  color: string;
}

const allFlowPointsInfowindow: google.maps.InfoWindow[] = [];

export const showFlowPoint = (params: ShowFlowPoint) => {
  return (dispatch: AppDispatch) => {
    const payload = {
      request: {
        ...(params.radius && params.center
          ? {
              location: params.center,
              radius: params.radius,
            }
          : { bounds: params.bounds }),
      },
      type: params.type || '',
      color: params.color,
    };

    dispatch(getGoogleFlowPoints(payload));
  };
};

export const removeFlowPoint = (flowItem: FlowPoint) => {
  flowItem.markers.forEach((marker) => {
    marker.setMap(null);
  });
};

export const removeAllFlowPoints = () => {
  allFlowPointsInfowindow.forEach((flowPoint) => flowPoint.setPosition(null));
  const flowPoints = Store.getState().dataLayersState.dataLayers.flowPoints;

  if (flowPoints.options) {
    flowPoints.options.map((flowPoint) => {
      removeFlowPoint(flowPoint);
    });
  }
};

type FlowPoints = {
  id: string;
  label: string;
  checked: boolean;
  color: string;
};

export const switchAllFlowPoints = (
  flowPointsList: FlowPoints[],
  params: Omit<ShowFlowPoint, 'type' | 'color'>
) => {
  return (dispatch: AppDispatch) => {
    flowPointsList.forEach((flowpoint, index) => {
      const payload = {
        request: {
          ...(params.radius && params.center
            ? {
                location: params.center,
                radius: params.radius,
              }
            : { bounds: params.bounds }),
        },
        type: flowpoint.id,
        color: flowpoint.color,
      };
      dispatch(getGoogleFlowPoints(payload));
    });
  };
};
